import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { useTheme } from '../contexts/ThemeProvider';
import { experience } from '../data/experience';

const Experience = forwardRef((props, ref) => {
	const color = useTheme();

	return (
		<ExperienceContainer color={color.color} ref={ref} id="experience">
			<div className="header">
				<h1>Experience</h1>
				<h3>_where i've worked</h3>
			</div>

			{experience.map((job) => (
				<div className="company" key={job.company}>
					<div className="company-header">
						<h2>{job.company}</h2>
						<p>{job.location}</p>
					</div>

					<div className="roles">
						{job.roles.map((role) => (
							<div className="role" key={role.title}>
								<div className="role-header">
									<h5>{role.title}</h5>
									<div className="tags">
										<span className="period">{role.period}</span>
										{role.note && <span className="note">{role.note}</span>}
									</div>
								</div>
								<ul>
									{role.bullets.map((bullet) => (
										<li key={bullet}>{bullet}</li>
									))}
								</ul>
							</div>
						))}
					</div>
				</div>
			))}
		</ExperienceContainer>
	);
});

export default Experience;

const ExperienceContainer = styled.div`
	background-color: ${({ color }) => color.background};
	color: ${({ color }) => color.text};
	width: 100vw;
	padding: 7rem 8rem 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2rem;

	.header {
		align-self: flex-start;
		h1 {
			color: ${({ color }) => color.text};
			text-transform: lowercase;
			font-size: 4rem;
			letter-spacing: 1px;
			font-weight: 800;
		}

		h3 {
			color: ${({ color }) => color.label};
			text-transform: lowercase;
			font-size: 1.5rem;
			letter-spacing: 1.5px;
		}
	}

	.company {
		width: 100%;
		border: 2px solid ${({ color }) => color.primary};
		border-radius: 3px;
		padding: 3rem;
		display: flex;
		flex-direction: column;
		gap: 2.5rem;

		.company-header {
			display: flex;
			align-items: baseline;
			justify-content: space-between;
			gap: 1rem;
			flex-wrap: wrap;
			h2 {
				font-size: 2.5rem;
				text-transform: lowercase;
				letter-spacing: 2px;
			}
			p {
				font-size: 1.3rem;
				color: ${({ color }) => color.label};
				letter-spacing: 1.5px;
			}
		}

		.roles {
			display: flex;
			flex-direction: column;
			gap: 2.5rem;
		}

		.role {
			border-left: 1px solid ${({ color }) => color.primary};
			padding-left: 1.5rem;
			display: flex;
			flex-direction: column;
			gap: 1rem;

			.role-header {
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 1rem;
				flex-wrap: wrap;

				h5 {
					font-size: 1.75rem;
					letter-spacing: 1.5px;
					color: ${({ color }) => color.text};
				}

				.tags {
					display: flex;
					gap: 0.75rem;
					span {
						font-size: 1.1rem;
						text-transform: lowercase;
						letter-spacing: 1.5px;
						border: 2px solid ${({ color }) => color.primary};
						padding: 0.2rem 0.75rem;
						color: ${({ color }) => color.primary};
					}
					.note {
						background-color: ${({ color }) => color.primary};
						color: ${({ color }) => color.background};
					}
				}
			}

			ul {
				display: flex;
				flex-direction: column;
				gap: 0.6rem;
				padding-left: 1.25rem;
				li {
					font-size: 1.25rem;
					line-height: 1.5;
					letter-spacing: 1.5px;
					color: ${({ color }) => color.label};
					&::marker {
						color: ${({ color }) => color.primary};
					}
				}
			}
		}
	}

	@media (max-width: 1024px) {
		padding: 2rem 3rem 0;
		margin-top: 3rem;
	}

	@media (max-width: 768px) {
		padding: 0 2rem;

		.company {
			padding: 2rem 1.5rem;
			.company-header h2 {
				font-size: 2rem;
			}
			.role {
				padding-left: 1rem;
				.role-header h5 {
					font-size: 1.4rem;
				}
				ul li {
					font-size: 1.1rem;
				}
			}
		}
	}
`;
